import { render, staticRenderFns } from "./BlockBubble.vue?vue&type=template&id=5cb4af1b&scoped=true"
import script from "./BlockBubble.vue?vue&type=script&lang=js"
export * from "./BlockBubble.vue?vue&type=script&lang=js"
import style0 from "./BlockBubble.vue?vue&type=style&index=0&id=5cb4af1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb4af1b",
  null
  
)

export default component.exports